import React from "react";
import { useUser } from "./contexts/UserContext";
import LoadingOverlay from "./components/Loading";
import { useLocation, Navigate } from "react-router-dom";

export function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useUser();
  const location = useLocation();

  if (isLoading) {
    return <LoadingOverlay />;
  }

  return user ? (
    <>{children}</>
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
}
